export * from "./client"

export interface UrlRecord {
  key: string
  url: string
  visitedCount: number
  username: string
  createTime: string
}
